'use strict';

var Clone = require('./lib/clone');

// Constructor
var EntryHeader = function() {

  var self = this;

  self.config = {
    'header'       :  '.entry-header',
    'cloneTarget'  :  '[data-clone-entry-header-up-to]'
  }

  self.init = function() {
    new Clone(self.config).init();
  }
};

module.exports = EntryHeader;
